import React, { ReactNode } from 'react'
import classNames from 'classnames'
import { Trans, t } from '@lingui/macro'
import { Link } from 'react-router-dom'

import { staticLinks } from '../../../../../shared/linkBuilder'
import './ErrorMessage.less'

const ErrorMessage = ({
  message = t`An error has occured`,
  error,
  children,
  tiny = false,
  includeLinkToDashboard = false
}: {
  message?: string
  children?: ReactNode
  error?: Error | null
  tiny?: boolean
  includeLinkToDashboard?: boolean
}) => {
  const cssClasses = classNames('ErrorMessage', {
    'Error--tiny': tiny
  })
  if (message === null) {
    return null
  }

  return (
    <div className={cssClasses}>
      {children || message}
      {error && <div className="Error__message">{error.message}</div>}
      {includeLinkToDashboard && (
        <div>
          <Link to={staticLinks.home}>
            <Trans>Return home</Trans>
          </Link>
        </div>
      )}
    </div>
  )
}

export default ErrorMessage
